import { useState } from 'react';
// @ts-expect-error - PatternValidationJS module lacks TypeScript declarations
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H2 } from 'foundations-components/transitional/components/H2';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProgressTransferModal = ({
  currentEmail,
  onConfirm,
  onReject,
  trackEvent
}) => {
  const [state, setState] = useState({
    invalidEmailError: false,
    destinationEmail: ''
  });
  const {
    destinationEmail,
    invalidEmailError
  } = state;
  const handleOnChange = event => {
    setState(() => ({
      destinationEmail: event.target.value,
      invalidEmailError: false
    }));
  };
  const showInvalidEmailError = () => {
    setState(prevState => Object.assign({}, prevState, {
      invalidEmailError: true
    }));
  };
  const handleSubmit = () => {
    const email = destinationEmail.toLowerCase();
    if (email === currentEmail || !email) {
      return;
    }
    if (EmailAddressPattern.test(email)) {
      trackEvent({
        action: 'certswap-submitted-email-address'
      });
      onConfirm(email);
    } else {
      showInvalidEmailError();
    }
  };
  const getErrorKey = () => {
    if (destinationEmail === currentEmail) {
      return 'sameEmail';
    } else if (invalidEmailError) {
      return 'invalidEmail';
    } else {
      return null;
    }
  };
  const errorKey = getErrorKey();
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "progress-transfer-modal",
    size: "auto",
    width: 500,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onReject
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.myTeam.transferModal.title"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(View, {
        as: "div",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "academyCommon.myTeam.transferModal.instructions",
          options: {
            currentEmail
          }
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        error: !!errorKey,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.myTeam.transferModal.emailInputLabel"
        }),
        validationMessage: errorKey && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyCommon.myTeam.transferModal.error.${errorKey}`
        }),
        children: /*#__PURE__*/_jsx(TextInput, {
          onChange: handleOnChange
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "progress-transfer-modal-confirm-button",
        onClick: handleSubmit,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.myTeam.transferModal.confirmButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "progress-transfer-modal-cancel-button",
        onClick: onReject,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.myTeam.transferModal.cancelButton"
        })
      })]
    })]
  });
};
export default ProgressTransferModal;